import React from "react";
import { LegacyCard, InlineGrid, TextField, Select } from "@shopify/polaris";
import { NameLabelColor } from "../CoatData";

const PartsOrderCuffForm = ({
  form,
  setForm,
  errors,
  baseUrl,
  setApploader,
  conditionalFieldsMap,
  viewOrder
}) => {
  const handleChange =
    (section, key = null) =>
      (values) => {
        const trimmedKey = key?.trim();
        let value;
        if (Array.isArray(values)) {
          value = values[0];
        } else {
          value = values;
        }

        const sectionMap = conditionalFieldsMap[section];
        const fieldRule = sectionMap?.[trimmedKey];

        if (fieldRule) {
          const { conditionValue, dependentKey } = fieldRule;
          if (value === conditionValue) {
            // Add the dependent field
            setForm((prev) => ({
              ...prev,
              [section]: {
                ...prev[section],
                [trimmedKey]: value,
                [dependentKey]: "",
              },
            }));
          } else {
            // Remove the dependent field
            const updatedSection = { ...form[section] };
            delete updatedSection[dependentKey];
            updatedSection[trimmedKey] = value;

            setForm((prev) => ({
              ...prev,
              [section]: updatedSection,
            }));
          }

          return;
        }
        // Default update
        if (trimmedKey) {
          setForm((prev) => ({
            ...prev,
            [section]: {
              ...prev[section],
              [trimmedKey]: value,
            },
          }));
        } else {
          setForm((prev) => ({
            ...prev,
            [section]: value,
          }));
        }
      };

  const PartsCuffFields = [
    {
      label: "Orginal Order Number",
      key: "orginalOrderNumber",
    },
    {
      label: "Cuff",
      key: "cuff",
      type: "select",
      options: ["1B Mitered", "1B Round", "1B Square", "2B Round", "Button + French", "Non Fold French", "French Sqaure", "French Mitered", "French Round"],
    },
    {
      label: "Font",
      key: "nameLabelFont",
      type: "select",
      options: ["Caligraphy", "Times Roman", "Block", "Script", "Bradley", "Old English", "Custom Upload"],
    },
    {
      label: "Color",
      key: "color",
      type: "select",
      options: NameLabelColor,
    },
    {
      label: "Size",
      key: "size",
      type: "select",
      options: ["Regular", "Small", "Large", "Extra Large"],
    },
    {
      label: "Text",
      key: "nameLabelText"
    },
  ];

  const handleFileUpload = async (section, key, file) => {
    const formData = new FormData();
    formData.append("image", file);
    setApploader(true);
    try {
      const res = await fetch(`${baseUrl}/api/files/upload`, {
        method: "POST",
        body: formData,
      });
      const data = await res.json();
      if (res.ok) {
        const uploadedFilename = data.files;
        handleChange(section, key)(uploadedFilename);
        setApploader(false);
      } else {
        alert("File upload failed");
      }
    } catch (error) { }
  };

  const handleDownload = async (url) => {
    try {
      const response = await fetch(url, { mode: "cors" });
      if (!response.ok) throw new Error("Network response was not ok");
      const blob = await response.blob();
      const blobUrl = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = url.split("/").pop() || "download.png";
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(blobUrl);
    } catch (error) {
    }

  };

  const renderSection = (title, fields, sectionKey) => (
    <LegacyCard title={title} sectioned>
      <InlineGrid columns={{ xs: 1, sm: 1, md: 2, lg: 3 }} gap="300">
        {fields.map(({ label, key, type = "text", options = [] }) => {
          if (type === "select") {
            return (
              <React.Fragment key={key}>
                <div className="two_culumn">
                  <Select
                    label={label}
                    options={options}
                    value={form[sectionKey]?.[key] || ""}
                    onChange={handleChange(sectionKey, key)}
                    error={errors[sectionKey]?.[key]}
                  />
                  {key === "nameLabelFont" &&
                    form[sectionKey]?.[key] === "Custom Upload" && (
                      <input
                        type="file"
                        className="imgUpload"
                        key="nameLabelFontFile"
                        accept=".jpg, .jpeg, .png"
                        onChange={(e) => {
                          const file = e.target.files[0];
                          if (!file) return;
                          handleFileUpload(
                            sectionKey,
                            "nameLabelFontFile",
                            file
                          );
                        }}
                        error={errors[sectionKey]?.["nameLabelFontFile"]}
                      />
                    )}
                  {viewOrder === 'yes' &&
                    form[sectionKey]?.[key] === "Custom Upload" && (
                      form.partsOrderCuff.nameLabelFontFile ? (
                        <img
                          className="image_server"
                          onClick={() => handleDownload(form.partsOrderCuff.nameLabelFontFile)}
                          src={form.partsOrderCuff.nameLabelFontFile}
                          alt="Mark Russell"
                        />
                      ) : null
                    )}
                </div>
              </React.Fragment>
            );
          }
          if (
            key === "nameLabelText" &&
            form[sectionKey]?.nameLabelFont === "Custom Upload"
          ) {
            return null;
          }
          return (
            <TextField
              key={key}
              label={label}
              value={form[sectionKey]?.[key] || ""}
              onChange={handleChange(sectionKey, key)}
              error={errors[sectionKey]?.[key]}
            />
          );
        })}
      </InlineGrid>
    </LegacyCard>
  );

  return renderSection("Part Order (Cuff)", PartsCuffFields, "partsOrderCuff");
};

export default PartsOrderCuffForm;
